/* Wonderwall — home sur mesure (hero + intro éditoriale + univers empilés). */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverable=matchMedia('(hover:hover)').matches;
  var isMobile=function(){return matchMedia('(max-width:820px)').matches};

  var stack=document.getElementById('uniStack');
  var uniPanels=stack?[].slice.call(stack.querySelectorAll('.uni__panel')):[];
  var sec=document.getElementById('univers'),hud=document.getElementById('uniHud'),
      uniNum=document.getElementById('uniNum'),uniBar=document.getElementById('uniBar'),
      topbar=document.getElementById('topbar'),intro=document.querySelector('.uni__intro');

  /* rideau + hero */
  function heroReveal(){
    var c=document.getElementById('curtain'); if(c) c.classList.add('up');
    var tt=document.getElementById('title'); if(tt) tt.classList.add('in');
    [['#eyebrow',.15],['#sub',.5],['#row',.65],['#cue',.9]].forEach(function(p){var e=document.querySelector(p[0]);if(e){e.style.transition='opacity .9s ease '+p[1]+'s, transform .9s cubic-bezier(.5,0,.1,1) '+p[1]+'s';e.style.opacity='1';e.style.transform='translateY(0)';}});
  }
  function afterPreloader(cb){var p=document.getElementById('wwpre');if(!p){cb();return;}var t=setInterval(function(){if(!document.getElementById('wwpre')){clearInterval(t);cb();}},100);setTimeout(function(){clearInterval(t);cb();},6000);}
  if(reduce){var p0=document.getElementById('wwpre');if(p0&&p0.remove)p0.remove();var t0=document.getElementById('title');if(t0)t0.classList.add('in');['#eyebrow','#sub','#row','#cue'].forEach(function(s){var e=document.querySelector(s);if(e){e.style.opacity=1;e.style.transform='none';}});}
  else{var kickHero=function(){afterPreloader(function(){setTimeout(heroReveal,120);});};
    if(document.readyState!=='loading')kickHero();else addEventListener('DOMContentLoaded',kickHero);}

  /* reveal au scroll (emblème / phrases) */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.2,rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.r').forEach(function(el){reduce?el.classList.add('in'):io.observe(el);});

  /* titres à lignes : révélés (arrivée des côtés) + glisse horizontale au scroll (intro + nouveautés) */
  var mtitles=[].slice.call(document.querySelectorAll('.uni__mtitle')).map(function(mt){
    return {el:mt, lines:[].slice.call(mt.querySelectorAll('.uni__tw'))};
  });
  mtitles.forEach(function(o){
    if(reduce){o.el.classList.add('in');}
    else{new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');}});},{threshold:.35}).observe(o.el);}
  });

  /* smooth scroll */
  var lenis=null; if(!reduce && window.Lenis && isMobile()){lenis=new Lenis({lerp:.09});}

  /* curseur */
  var cur=document.getElementById('cursor');
  var mx=innerWidth/2,my=innerHeight/2,cx=mx,cy=my;
  if(cur && hoverable && !reduce){
    addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;});
  } else if(cur){cur.style.display='none';}

  /* HUD compteur — visible seulement dans la section univers */
  if(sec && hud && !isMobile() && !reduce && !document.getElementById('rideau')){
    new IntersectionObserver(function(es){es.forEach(function(e){hud.classList.toggle('show',e.isIntersecting);});},{threshold:0}).observe(sec);
  }

  /* boucle rAF : curseur + parallax + HUD + teinte du menu */
  function frame(t){
    if(lenis) lenis.raf(t);
    if(cur){cx+=(mx-cx)*.16; cy+=(my-cy)*.16; cur.style.left=cx+'px'; cur.style.top=cy+'px';}
    if(topbar && intro && !isMobile()){var ir=intro.getBoundingClientRect();topbar.classList.toggle('on-light', ir.top<=44 && ir.bottom>=44);}
    if(mtitles.length && !isMobile() && !reduce){
      for(var mi=0;mi<mtitles.length;mi++){
        var o=mtitles[mi]; if(!o.lines.length) continue;
        var mr=o.el.getBoundingClientRect();
        /* centré tant que le titre monte jusqu'au milieu (prog 0), puis écarté en sortant par le haut (prog 1) */
        var tc=mr.top+mr.height/2;
        var prog=(innerHeight*0.5 - tc)/(innerHeight*0.5 + mr.height*0.5);
        prog=prog<0?0:prog>1?1:prog;
        var cw=o.el.clientWidth;
        for(var li=0;li<o.lines.length;li++){
          var tl=o.lines[li].firstElementChild;
          var lw=tl?tl.offsetWidth:0;
          var maxOff=Math.max(0,(cw-lw)/2)*0.4; /* écartement doux : 40% du chemin vers le bord */
          var dir=li===0?-1:1;            /* 1re ligne vers la gauche, 2e vers la droite */
          o.lines[li].style.transform='translateX('+(dir*maxOff*prog).toFixed(1)+'px)';
        }
      }
    }
    if(sec){
      var ur=sec.getBoundingClientRect();
      if(!isMobile() && !reduce){
        var active=0;
        for(var i=0;i<uniPanels.length;i++){
          var r=uniPanels[i].getBoundingClientRect();
          var img=uniPanels[i].querySelector('.uni__media img');
          if(img){var prog=(r.top+r.height/2)/innerHeight;img.style.transform='translateY('+((prog-0.5)*9).toFixed(2)+'%)';}
          if(r.top<=innerHeight*0.42) active=i;
        }
        if(uniNum) uniNum.textContent='0'+(active+1);
        if(uniBar){var total=sec.offsetHeight-innerHeight;var p=total>0?Math.min(1,Math.max(0,-ur.top/total)):0;uniBar.style.transform='scaleX('+p.toFixed(3)+')';}
      }
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  /* menu tiroir : ouverture / fermeture (accessible) */
  var drawer=document.getElementById('drawer'),menuOpen=document.getElementById('menuOpen'),
      menuClose=document.getElementById('menuClose'),menuScrim=document.getElementById('menuScrim');
  function setDrawer(o){
    if(!drawer)return;
    drawer.classList.toggle('open',o);
    drawer.setAttribute('aria-hidden',o?'false':'true');
    if(menuOpen)menuOpen.setAttribute('aria-expanded',o?'true':'false');
    if(isMobile())document.body.style.overflow=o?'hidden':'';
    if(lenis){o?lenis.stop():lenis.start();}
    if(o){var ff=menuClose||drawer;if(ff&&ff.focus)ff.focus();}
    else if(menuOpen&&menuOpen.focus){menuOpen.focus();}
  }
  if(menuOpen)menuOpen.addEventListener('click',function(){setDrawer(true);});
  if(menuClose)menuClose.addEventListener('click',function(){setDrawer(false);});
  if(menuScrim)menuScrim.addEventListener('click',function(){setDrawer(false);});
  addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer&&drawer.classList.contains('open'))setDrawer(false);});
  /* piège de focus dans le tiroir ouvert */
  if(drawer)drawer.addEventListener('keydown',function(e){
    if(e.key!=='Tab'||!drawer.classList.contains('open'))return;
    var f=drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    if(!f.length)return;
    var first=f[0],last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
  });

  /* back-to-top (home longue) */
  var backTop=document.getElementById('backTop');
  if(backTop){
    backTop.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});});
    var btShow=function(){backTop.classList.toggle('show',(window.scrollY||window.pageYOffset)>innerHeight*1.4);};
    addEventListener('scroll',btShow,{passive:true}); btShow();
  }

  /* mobile : cartes univers empilées → toute la carte est tappable vers la collection */
  if(isMobile()){
    uniPanels.forEach(function(panel){
      var link=panel.querySelector('.uni__cta');
      if(!link) return;
      panel.addEventListener('click',function(e){
        if(e.target.closest('a')) return;
        window.location=link.getAttribute('href');
      });
    });
  }

  /* favoris (localStorage) */
  (function(){
    var KEY='ww_favs';
    function get(){try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(e){return [];}}
    function set(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
    function mark(el,on){
      el.classList.toggle('is-fav',on);
      el.setAttribute('aria-pressed',on?'true':'false');
      var txt=el.querySelector('.pb__fav-txt');
      if(txt) txt.textContent=on?'Dans vos favoris':'Ajouter aux favoris';
      if(el.classList.contains('pcard__fav')) el.setAttribute('aria-label',on?'Retirer des favoris':'Ajouter aux favoris');
    }
    function count(){var b=document.getElementById('favCount');if(!b)return;var n=get().length;b.textContent=n;b.hidden=(n===0);}
    function refresh(){
      var favs=get();
      document.querySelectorAll('[data-fav]').forEach(function(el){mark(el,favs.indexOf(el.getAttribute('data-fav'))>-1);});
      count();
    }
    function toggle(el){
      var h=el.getAttribute('data-fav'); if(!h)return;
      var favs=get(), i=favs.indexOf(h);
      if(i>-1) favs.splice(i,1); else favs.push(h);
      set(favs); mark(el,i<0); count();
    }
    document.addEventListener('click',function(e){
      var el=e.target.closest('[data-fav]'); if(!el)return;
      e.preventDefault(); e.stopPropagation(); toggle(el);
    });
    document.addEventListener('keydown',function(e){
      if(e.key!=='Enter'&&e.key!==' ')return;
      var el=e.target.closest('.pcard__fav[data-fav]'); if(!el)return;
      e.preventDefault(); toggle(el);
    });
    refresh();
  })();
})();

/* ===== Reveal spectaculaire (pages Inspiration) : entree fluide + rejeu bidirectionnel ===== */
(function(){
  if(!document.querySelector('.ed')) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var maskSel='.ed__display,.ed__h,.ihrow__title';
  var imgSel='.ed__full,.ed__split-media,.ed__feature-media,.ed__edit-media,.ed__diptych>div,.ihrow__media,.ed__bleed,.ed__detail-media';
  var riseSel='.ed__cover-in>.ed__kicker,.ed__cover-in>.ed__deck,.ed__manifesto>p,.ed__cap,.ed__split-text>*,.ed__statement>*,.ed__feature-info>*,.ed__edit-head>*,.ed__editrow,.ed__strip-head>*,.ed__strip-grid>*,.ed__close>*,.ed__pal,.ed__code,.ed__step,.ed__duo-col,.ed__tri-item,.ed__room,.ihhero>.ed__kicker,.ihhero__lead,.ihrow__text>.ed__kicker,.ihrow__desc,.ihrow__cta';

  var all=[];
  /* titres : envelopper le contenu dans un cache glissant */
  [].slice.call(document.querySelectorAll(maskSel)).forEach(function(h){
    if(h.__rv) return; h.__rv=1;
    var inner=document.createElement('span'); inner.className='rvin';
    while(h.firstChild) inner.appendChild(h.firstChild);
    h.appendChild(inner); h.classList.add('rvmask'); all.push(h);
  });
  /* images */
  [].slice.call(document.querySelectorAll(imgSel)).forEach(function(w){ if(w.__rv||!w.querySelector('img'))return; w.__rv=1; w.classList.add('rvimg'); all.push(w); });
  /* cover : zoom d'ouverture */
  [].slice.call(document.querySelectorAll('.ed__cover-img')).forEach(function(c){ if(c.__rv)return; c.__rv=1; all.push(c); });
  /* textes/blocs (on saute ce qui est deja pris par un masque) */
  [].slice.call(document.querySelectorAll(riseSel)).forEach(function(el){ if(el.__rv)return; el.__rv=1; el.classList.add('rvup'); all.push(el); });
  if(!all.length) return;

  /* cascade : delai croissant par ordre DOM au sein d'un conteneur groupe */
  ['.ed__cover-in','.ihhero','.ed__close','.ed__feature-info','.ed__split-text','.ed__edit-list','.ed__strip-grid','.ed__diptych','.ed__statement','.ihrow__text','.ed__edit-head','.ed__strip-head'].forEach(function(gs){
    [].slice.call(document.querySelectorAll(gs)).forEach(function(g){
      var i=0;
      [].slice.call(g.querySelectorAll('.rvmask,.rvup,.rvimg')).forEach(function(c){
        if(c.closest(gs)!==g) return;                 /* n'appartient qu'a ce groupe */
        var d=(i*85)+'ms';
        if(c.classList.contains('rvmask')){ var ri=c.querySelector('.rvin'); if(ri) ri.style.transitionDelay=d; }
        else { c.style.transitionDelay=d; if(c.classList.contains('rvimg')){ var im=c.querySelector('img'); if(im) im.style.transitionDelay=d; } }
        i++;
      });
    });
  });

  if(reduce){ all.forEach(function(e){ e.classList.add('rv-in'); }); return; }

  /* revele a l'entree, retire a la sortie complete -> se rejoue quand l'element revient (haut ou bas) */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ e.target.classList.toggle('rv-in', e.isIntersecting); });
    },{threshold:0, rootMargin:'0px 0px -12% 0px'});
    all.forEach(function(e){ io.observe(e); });
  } else {
    all.forEach(function(e){ e.classList.add('rv-in'); });
  }
})();

/* ===== Univers : rideau plein écran au survol (desktop) ===== */
(function(){
  var riv=document.getElementById('rideau'); if(!riv) return;
  if(window.matchMedia && matchMedia('(max-width:820px)').matches) return;   /* desktop only ; mobile = empilés */
  var layers=[].slice.call(riv.querySelectorAll('.riv__layer'));
  var items=[].slice.call(riv.querySelectorAll('.riv__item'));
  var desc=riv.querySelector('.riv__desc');
  var z=1, cur=-1, dT;
  function activate(i){
    if(i===cur) return; cur=i;
    for(var k=0;k<items.length;k++) items[k].classList.toggle('on', k===i);
    if(layers[i]){ layers[i].style.zIndex=(++z); layers[i].classList.add('on'); }   /* le motif se déroule par-dessus */
    if(desc){ var d=items[i].getAttribute('data-desc')||''; desc.style.opacity=0; clearTimeout(dT); dT=setTimeout(function(){ desc.textContent=d; desc.style.opacity=1; },180); }
  }
  items.forEach(function(it,i){ it.addEventListener('mouseenter', function(){ activate(i); }); });
  activate(0);
})();

/* ===== Curseur spectaculaire, section-aware + magnétique (desktop) ===== */
(function(){
  var cur=document.getElementById('cur'); if(!cur) return;
  if(!(window.matchMedia && matchMedia('(hover:hover)').matches) || matchMedia('(prefers-reduced-motion:reduce)').matches){ cur.style.display='none'; return; }
  var dot=cur.querySelector('.cur__dot'), ring=cur.querySelector('.cur__ring'), label=cur.querySelector('.cur__label');
  if(!dot||!ring||!label) return;
  var SEL='a,button,[data-cursor],.cx__cta,.uni__cta,input,textarea,select,summary,.topbar__ico,.topbar__nav a,.topbar__burger';
  var MAG='.cx__cta,.uni__cta,.cta,.dfl__cta,.link-ghost,.topbar__ico,.topbar__burger,.drawer__wa,.drawer__tel,.news__more,button,.ed__cta,.pb__preview,.pb__ask,.proc__sim-wa,.quiz__rshop,.quiz__rwa,.cfilter__tag,.chead__back,.ihrow__cta,.bcard__more,.ww-faq__more';
  var mx=innerWidth/2, my=innerHeight/2, dx=mx, dy=my, rx=mx, ry=my, rw=40, rh=40, rr=20;
  var hov=null, magEl=null, mgx=0, mgy=0, down=false, shown=false;

  addEventListener('mousemove', function(e){ mx=e.clientX; my=e.clientY; if(!shown){shown=true;cur.style.opacity=1;} }, {passive:true});
  document.addEventListener('mouseleave', function(){ cur.style.opacity=0; }, {passive:true});
  document.addEventListener('mouseenter', function(){ if(shown) cur.style.opacity=1; }, {passive:true});
  addEventListener('mousedown', function(){ down=true; }, {passive:true});
  addEventListener('mouseup', function(){ down=false; }, {passive:true});

  document.addEventListener('mouseover', function(e){
    var t=(e.target.closest)?e.target.closest(SEL):null;
    if(t!==hov){ hov=t; applyHover(); }
  }, {passive:true});
  function applyHover(){
    if(hov){
      cur.classList.add('is-hover');
      var isMag = false;   /* magnétisme désactivé : l'aimantation déformait les boutons (translate) */
      var l=hov.getAttribute('data-cursor');
      if(l && !isMag){ label.textContent=l; cur.classList.add('is-label'); cur.classList.remove('is-flash'); }
      else cur.classList.remove('is-label');
      if(isMag){ magEl=hov; cur.classList.add('is-wrap'); } else cur.classList.remove('is-wrap');
    } else { cur.classList.remove('is-hover','is-label','is-wrap'); }
  }

  /* thème par section + flash du nom */
  var themed=[]; [['univers','univers','Nos univers'],['nouveautes','light','Nouveautés']].forEach(function(m){ var el=document.getElementById(m[0]); if(el) themed.push({el:el,t:m[1],n:m[2]}); });
  var theme='', flashT;
  function flash(n){ if(!n||hov) return; label.textContent=n; cur.classList.add('is-flash'); clearTimeout(flashT); flashT=setTimeout(function(){cur.classList.remove('is-flash');},1250); }
  function pickSection(){ var cyc=innerHeight*0.5,t='dark',n=null; for(var i=0;i<themed.length;i++){var r=themed[i].el.getBoundingClientRect();if(r.top<=cyc&&r.bottom>=cyc){t=themed[i].t;n=themed[i].n;break;}} if(t!==theme){theme=t;document.body.setAttribute('data-cur',t);flash(n);} }
  addEventListener('scroll', pickSection, {passive:true}); pickSection();

  function frame(){
    var wrapping = magEl && hov===magEl;
    var tgx=mx, tgy=my, tw=40, th=40, tr=20, mtx=0, mty=0;
    if(wrapping){
      var r=magEl.getBoundingClientRect();
      var curCX=r.left+r.width/2, curCY=r.top+r.height/2;   /* centre actuel (avec l'aimantation) */
      var restCX=curCX-mgx, restCY=curCY-mgy;               /* centre au repos (stable) */
      tgx=curCX; tgy=curCY;                                 /* l'anneau suit le bouton */
      tw=r.width+18; th=r.height+18; tr=Math.min(th/2,40);  /* pilule autour du bouton */
      mtx=(mx-restCX)*0.34; mty=(my-restCY)*0.34;           /* le bouton vient vers le curseur */
    } else if(hov){ tw=62; th=62; tr=31; }                  /* survol simple : anneau grossi */
    if(down){ tw*=0.82; th*=0.82; tr*=0.82; }               /* clic : contraction */
    if(magEl){
      mgx+=(mtx-mgx)*0.20; mgy+=(mty-mgy)*0.20;
      magEl.style.transform='translate('+mgx.toFixed(2)+'px,'+mgy.toFixed(2)+'px)';
      if(!wrapping && Math.abs(mgx)<0.4 && Math.abs(mgy)<0.4){ magEl.style.transform=''; magEl=null; cur.classList.remove('is-wrap'); }
    }
    rx+=(tgx-rx)*(wrapping?0.22:0.17); ry+=(tgy-ry)*(wrapping?0.22:0.17);
    rw+=(tw-rw)*0.22; rh+=(th-rh)*0.22; rr+=(tr-rr)*0.22;
    ring.style.left=rx.toFixed(2)+'px'; ring.style.top=ry.toFixed(2)+'px';
    ring.style.width=rw.toFixed(2)+'px'; ring.style.height=rh.toFixed(2)+'px'; ring.style.borderRadius=rr.toFixed(2)+'px';
    dx+=(mx-dx)*0.38; dy+=(my-dy)*0.38;
    dot.style.left=dx.toFixed(2)+'px'; dot.style.top=dy.toFixed(2)+'px';
    label.style.left=rx.toFixed(2)+'px'; label.style.top=ry.toFixed(2)+'px';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* Rails « coup de cœur » + sélections par âge : défilement au survol des bords + curseur flèche (type Webflow), multi-rails */
(function(){
  var rails=[].slice.call(document.querySelectorAll('.coeur__rail')); if(!rails.length) return;
  var cursor=document.getElementById('coeurCursor'); if(!cursor) return;
  if(!(window.matchMedia && matchMedia('(hover:hover)').matches) || matchMedia('(prefers-reduced-motion:reduce)').matches){ return; }
  var globalCur=document.getElementById('cur');
  var current=null, speed=0, raf=null;
  var DEAD=0.18, MAX=16;   /* zone neutre centrale (±18%) ; vitesse max px/frame vers les bords */
  function onMove(e){
    if(!current) return;
    cursor.style.left=e.clientX+'px'; cursor.style.top=e.clientY+'px';
    cursor.classList.add('is-on');
    var r=current.getBoundingClientRect(); if(!r.width) return;
    var px=(e.clientX-r.left)/r.width; if(px<0)px=0; if(px>1)px=1;
    cursor.classList.toggle('is-left', px<0.5);
    var d=px-0.5, canScroll=current.scrollWidth>current.clientWidth+4;
    if(!canScroll || Math.abs(d)<=DEAD){ speed=0; cursor.classList.add('is-dim'); }
    else { var t=(Math.abs(d)-DEAD)/(0.5-DEAD); speed=(d<0?-1:1)*MAX*t; cursor.classList.remove('is-dim'); }
  }
  function loop(){ if(!current) return; if(speed){ current.scrollLeft+=speed; } raf=requestAnimationFrame(loop); }
  rails.forEach(function(rail){
    rail.addEventListener('mouseenter', function(){ current=rail; if(globalCur) globalCur.style.opacity=0; cancelAnimationFrame(raf); raf=requestAnimationFrame(loop); });
    rail.addEventListener('mousemove', function(e){ current=rail; onMove(e); }, {passive:true});
    rail.addEventListener('mouseleave', function(){ if(current!==rail) return; current=null; speed=0; cursor.classList.remove('is-on'); if(globalCur) globalCur.style.opacity=1; cancelAnimationFrame(raf); });
  });
})();
